import { Foundation } from 'foundation-sites/js/foundation.core'
import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll'
// eslint-disable-next-line no-unused-vars
;(function ($) {
	if (!jQuery().foundation) {
		Foundation.addToJquery($)
	}

	if (typeof Foundation.SmoothScroll === 'undefined') {
		Foundation.plugin(SmoothScroll, 'SmoothScroll')
	}
	$('.smooth-scroll').foundation()
})(jQuery)
